// removed by extract-text-webpack-plugin
module.exports = {"button":"_2LE9bLhjmUFEvtqJiTPXBH"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63bc22ef","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/live-coach-call/toolbar/leave-button/leave-button.less
// module id = e5QJ
// module chunks = 1